
import { localDateToUSFormat } from '../../general_components/content_management/item_page/driver_page_components/payoutAdjustmentsSection';
import { LatestActivitiesSection } from '../../general_components/content_management/item_page/latestActivitiesSection';
import { generateColumn, TRAILER_SECTION_UPDATE } from '../../supplementary_components/itemEditMethods';
import { API_ROOT } from '../../supplementary_components/requests';
import { dateFormatter, generateRandomString } from '../../supplementary_components/supplementaryMethods';
import { dateStringToLocalDateString } from '../reports/weeklyReports';
import { equipmentPurchaseColumns, confirmIfPurchaseTypeDropsHistory } from '../reports/equipmentPaymentFields';

export function castTrailerStatus(value, toFrontEnd){
    if(toFrontEnd){
        if (value === "AtShop") return "At Shop";
        if (value === "OutOfOrder") return "Out Of Order";
        if (value === "Terminated") return "Terminated";
    }else{
        if (value === "At Shop") return "AtShop";
        if (value === "Out Of Order") return "OutOfOrder";
        if (value === "Terminated") return "Terminated";
    }
    return value;
}

export class TRAILER_PAGE_OBJECT {
    
    operationalColumns = ()=>{
        const columns = [
            {
                // Active,
            // OutOfOrder,
            // AtShop,
            // Pending
                notInAddForm:true,
                label: 'Status',
                name: "trailerStatus",
                val: castTrailerStatus(this.data['trailerStatus'], true),
                type: "select",
                dataset: ["Active", "Out Of Order", "At Shop", "Pending", "Terminated"],
                // conditionalFormatting: (value) => {
                //     return `& > * {color:var(--successGreen); font-weight:900; }`;
                // },
                processBeforeSending : val => {
                    return castTrailerStatus(val, false);;
                },
                defaultValue:()=>{
                    return castTrailerStatus(this.data['trailerStatus'], true);
                }
            },
            {
                notInAddForm:true,
                label: "PM Due Date",
                name: 'pmDueDate',
                autoComplete:"off",
                hasConstraints:true,
                checks : [
                    (value) => {
                        const res = dateFormatter(value);
                        if(res.date === null){
                            return 'Invalid Input'
                        }
                        return null;
                    }
                ],
                onblur:(val, tar)=>{
                    return dateFormatter(val).date || val;
                },
                defaultValue: ()=>{
                    return this.data.pmDueDate? localDateToUSFormat(this.data.pmDueDate):"";
                    // const defaultDate = editingAdjustment.date.split('-');
                    // return `${defaultDate[1]}/${defaultDate[2]}/${defaultDate[0].slice(-2)}`
                },
                val: this.data.pmDueDate? localDateToUSFormat(this.data.pmDueDate):"-",
                processBeforeSending : val => {
                    return val !== null && val !== "" ? dateStringToLocalDateString(val) : null;
                },
            },
        ];
        if (this.data?.thirdPartyTrailer) {
            return columns.filter((column) => column.name !== 'pmDueDate');
        }
        return columns;
    }
    trailerDetailsSectionColumns = ()=>{
        return [
            
            {
                label: "Trailer Type",
                val: this.data['trailerType'] || "-",
                name: "trailerType",
                nameInAddConfForm: 'trailerType',
                defaultValue:()=>{
                    return castTrailerStatus(this.data['trailerType'], true);
                }
                // processBeforeSending: val => {
                //     return (val === "Company Trailer");
                // },
            },
            {
                label: 'Trailer Number',
                val: this.trailerNumber,
                nameInAddConfForm: 'trailerNumber',
                defaultValue:()=>{
                    return this.trailerNumber
                }
            },
            this.data.thirdPartyTrailer ? 
            {
                notInAddForm:true,
                label: 'Owned By',
                name: "ownerCompanyName",
                val: this.data['ownerCompanyName'] ? this.data['ownerCompanyName'] : "-" ,
                defaultValue:()=>{
                    return this.data['ownerCompanyName'] ? this.data['ownerCompanyName'] : "" 
                }
            } : {
                label: 'Make',
                val: this.data['make']|| "-",
                nameInAddConfForm: 'make',
                defaultValue:()=>{
                    return this.data['make']
                }
            },
            this.data.thirdPartyTrailer ?  null : {
                label: 'Model',
                val: this.data['model'] || "-",
                nameInAddConfForm: 'model',
                defaultValue:()=>{
                    return this.data['model']
                }
            },
            this.data.thirdPartyTrailer ?  null : {
                label: 'Vin',
                val: this.data['vin'],
                nameInAddConfForm: 'vin',
                defaultValue:()=>{
                    return this.data['vin']
                }
            },
            this.data.thirdPartyTrailer ?  null : {
                label: 'Year',
                val: this.data['year'],
                nameInAddConfForm: 'year',
                defaultValue:()=>{
                    return this.data['year']
                }
            },
            this.data.thirdPartyTrailer ?  null : {
                label: 'License Plate',
                val: this.data['licensePlate'],
                nameInAddConfForm: 'licensePlate',
                defaultValue:()=>{
                    return this.data['licensePlate']
                }
            },
            ...equipmentPurchaseColumns(this.data),
        ]
    }
    staticColumns = ()=>{
        return [
            generateColumn(this.data, true, "Company", [["company", "companyName"]]),
        ]
    }
    constructor(){
        this.getLink = API_ROOT+'trailers/';
        this.columnProportions = "20rem 1fr 0.7fr";
    }
    setData(data){
        this.data = data;
        this.id = data['id'];
        // this.truckNumber = data['truckNumber'];
        this.trailerNumber = data['trailerNumber'];
        // this.firstDriverFN = NestedValueExtractor(data, [["driver1", "firstName"], ' ', ['driver1', 'lastName']]);
        this.notes = data['notes'];
    
        this.header = {
            title : "Trailer " + this.trailerNumber,
            
        };
        const thirdParty = Boolean(this.data.thirdPartyTrailer);
        const editAccessLevel = thirdParty
            ? { key: 'TRAILERS', level: 'VIEW' }
            : { key: 'TRAILERS', level: 'MANAGE' };
        const editLink = thirdParty ? API_ROOT + 'trailers/edit-third-party' : undefined;
        this.infoSections = [
            {
                title: 'Overview',
                editAccessLevel,
                editButton : {
                    text: 'Edit',
                    action: (setDataMethod)=>{
                        TRAILER_SECTION_UPDATE(setDataMethod, this.data.id, this.operationalColumns, null, editLink);
                    }
                },
                columns : this.operationalColumns()
            },
            {
                title: 'Trailer Details',
                editAccessLevel,
                editButton : {
                    text: 'Edit',
                    action: (setDataMethod)=>{
                        TRAILER_SECTION_UPDATE(setDataMethod, this.data.id, this.trailerDetailsSectionColumns, thirdParty ? null : async (submitted) => {
                            const next = submitted?.purchaseType || null;
                            if (this.data.purchaseTypeConfirmed && this.data.purchaseTypeConfirmed === (next || '')) return;
                            const proceed = await confirmIfPurchaseTypeDropsHistory(this.data.purchaseType, next);
                            if (!proceed) return { cancelSubmission: true };
                        }, editLink);
                    }
                },
                columns : this.trailerDetailsSectionColumns()
            },
            ...(thirdParty ? [] : [{
                title: 'Owned By',
                columns : this.staticColumns()
            }])
        ]
        this.overviewSection = [
            {
                title : `Used on loads`,
                type: 'content'
            },
            {
                title : `Latest Activities`,
                content: ()=>{
                    return <LatestActivitiesSection type="TRAILER" objectId={this.id} refreshKey={generateRandomString(4)}  />
                },
                headerLine :true
            }
        ]
        this.notesSection = {

        }
    }
}